export const normalizeTrailNameKey = (value) => {
  if (!value) return null;
  return encodeURIComponent(String(value)).replace(/\./g, "_");
};

export const getTrailNameKeys = (trail) => {
  const keys = [];
  const fileKey = normalizeTrailNameKey(trail?.cloud?.file);
  const urlKey = normalizeTrailNameKey(trail?.cloud?.url);
  if (fileKey) keys.push(fileKey);
  if (urlKey && urlKey !== fileKey) keys.push(urlKey);
  return keys;
};

export const getTrailNameKey = (trail) => getTrailNameKeys(trail)[0] || null;
